<link
  href="https://fonts.googleapis.com/icon?family=Material+Icons"
  rel="stylesheet"
/>

<section class="hero-container container">
  <div class="hero-image">
    <img
      src="assets/images/uxdesign/ux.webp"
      alt="UI/UX Design Illustration"
      loading="lazy"
    />
  </div>
  <div class="hero-content mt-3">
    <div class="line"></div>
    <h1>UX Design That Delivers Impact</h1>
    <p class="px-0">
      At MALtech, we craft seamless UI/UX experiences that connect users with
      technology in the most intuitive way. Our designs balance aesthetics,
      usability, and functionality to maximize business success.
    </p>
    <a routerLink="/contact" href="/contact" class="btn cta-button"> Work Together</a>
  </div>
</section>

<section class="services-section pt-3 pt-md-5" id="get-start">

  <div class="container">
    <h2 class="title mb-3">Our UI/UX Design Services</h2>
    <p class="subtitle mb-4 text-center">
      MALtech creates user-first digital experiences that merge research,
      creativity, and technology to deliver designs that delight users and
      achieve business goals.
    </p>

    <div class="row row-cols-1 row-cols-md-3 g-4">
      <div class="col" *ngFor="let service of services">
        <div
          class="card h-100 service-card p-3"
          [ngClass]="{ 'border-primary': service.active }"
        >
          <!-- Bootstrap Icon -->
          <div class="icon mb-3 text-center">
            <i class="bi bi-{{ service.icon }} fs-2"></i>
          </div>

          <h5 class="service-title text-center">{{ service.title }}</h5>
          <p class="service-desc text-center">{{ service.description }}</p>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="tools-section">
  <div class="container">
    <h2 class="title">Tools & Platforms We Use</h2>
    <p class="subtitle">
      At MALtech, we leverage leading design tools like Figma, Adobe XD, Sketch,
      Photoshop, Illustrator, and Canva to create intuitive, scalable, and
      visually engaging experiences.
    </p>

    <div class="image-grid">
      <div class="tool-card" *ngFor="let tool of platforms">
        <img [src]="tool.img" [alt]="tool.name" loading="lazy" />
      </div>
    </div>
  </div>
</section>

<section class="tools-section mt-5">
  <div class="container">
    <h2 class="section-title">What We Do Using These Tools</h2>

    <div class="cards-container mx-0 mx-md-5 px-2 justify-content-center">

      <div class="card  mx-auto" *ngFor="let tool of tools">
        <i class="bi tool-icon" [ngClass]="tool.icon"></i>
        <h3>{{ tool.title }}</h3>
        <p>{{ tool.description }}</p>
      </div>
    </div>
  </div>
</section>

<section class="approach-container">
  <div class="container">
    <h2 class="title">Our Approach to Design</h2>

    <div class="cards">
      <div class="card text-center p-3 rounded hover-icon">
        <div class="icon mb-3">
          <i class="bi bi-people-fill fs-3"></i>
        </div>
        <h3>User Research</h3>
        <p>Understand your customer’s real needs.</p>
      </div>

      <div class="card text-center p-3 rounded hover-icon">
        <div class="icon mb-3">
          <i class="bi bi-pencil-square fs-3"></i>
        </div>
        <h3>Wireframes & Prototypes</h3>
        <p>Validate ideas before heavy investment.</p>
      </div>

      <div class="card text-center p-3 rounded hover-icon">
        <div class="icon mb-3">
          <i class="bi bi-check2-square fs-3"></i>
        </div>
        <h3>Testing & Iteration</h3>
        <p>Ensure your product is usable, accessible, and effective.</p>
      </div>
    </div>
  </div>
</section>

<section class="why-container container">
  <div class="image-section">
    <img
      src="assets/images/uxdesign/why-maltech.webp"
      alt="Why MALtech"
      loading="lazy"
    />
  </div>

  <div class="content-section">
    <h2 class="title">Why MALtech</h2>
    <p class="highlight">
      <strong>
        Trusted by Fortune 500 clients, MALtech’s UX team has improved
        conversion rates by up to 35% through user-centered design.
      </strong>
    </p>

    <p>
      At MALtech, we go beyond visuals. we create user-centered designs that
      enhance usability, boost engagement, and align seamlessly with your brand
      identity. From research and wireframing to testing and delivery, our UX
      approach ensures intuitive and impactful digital experiences.
    </p>

    <p>
      With expertise in Figma, Adobe XD, Sketch, Photoshop, Illustrator, and
      Canva, we craft interfaces that are clean, modern, and scalable. By
      blending creativity with strategy, MALtech becomes your trusted partner in
      building designs that not only look good but also drive real business
      success.
    </p>
  </div>
</section>

<section class="cta-container">
  <div class="container">
    <h2 class="title">Let’s Design the Future Together</h2>
    <p class="subtitle text-center">
      Partner with MALtech to design meaningful experiences that inspire trust,
      engage users at every touchpoint, and convert interactions into lasting
      business success.
    </p>
    <a
      [routerLink]="['/contact']" [href]="['/contact']"
      rel="noopener noreferrer"
      class="btn cta-btn"
      aria-label="Contact Us"
    >
      Contact Us 
    </a>
  </div>
</section>
